module.exports = __webpack_public_path__ + "static/media/jam-night-winter.f110667d.jpg";